import React from 'react';

import AssetsCreditSignContainer from '../../../containers/assets-credit-sign-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';

const CreditSignPage: React.FC = () => (
  <AppPageMain>
    <div className="container">
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <PageHeader
            items={[
              { link: '/assets', title: 'Активы' },
              { link: '#', title: 'Займы' },
            ]}
            iconType="assets"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <AssetsCreditSignContainer />
        </div>
      </div>
    </div>
  </AppPageMain>
);

export default CreditSignPage;
